import axios from "axios";
export const HelpersMixin = {
  data() {
    return {};
  },
  methods: {
    isInputKey(key) {
      //Special Chars
      if (key >= 186 && key <= 222) {
        return true;
      }
      //Alphanumeric, !@#$&()
      var inp = String.fromCharCode(key);
      if (/[a-zA-Z0-9!@#$&()]/.test(inp)) {
        return true;
      }
      //Backspace, delete and space
      if (key === 8 || key === 46 || key === 32) {
        return true;
      }
      return false;
    },
    setMobileNumberToCountryCode(val) {
      const countryIndex = this.country.options.findIndex(
        country => country.code === val
      );
      const dialCode = this.country.options[countryIndex].dialCode;
      this.mobileNumber.value = "+" + this.sanitiseMobileNumber(dialCode);
    },
    restrictMobileNumberValue(val) {
      if (val == "+0") {
        this.setMobileNumberToCountryCode(this.countryValue);
      }
      if (val == "+270") {
        val = "+27";
        this.mobileNumber.value = val;
      }
    },
    //Get the Hubspot Tracking Code from the cookie
    getHsTrackingCode() {
      const hsCookie = 'hubspotutk';
      var value = "; " + document.cookie;
      var parts = value.split("; " + hsCookie + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
      return "";
    },
    triggerGtmThankYouEvent() {
      window.dataLayer.push({
        event: "form-completed-thank-you",
        form: location.pathname
      });
    }
  }
};
